//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';
//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";

import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import { categoryActions, productActions, userActions } from "../../_actions";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '250px'
    },
    boldText: {
        fontWeight: 'bold'
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    }
});

class ViewShopProducts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            productAdd: false,
            allCategories: [],
            soldIndChecked: false,
            viewProductData: false,
            enableEdit: false,
            deletingProdId: false,
            deletePopup: false
        };
    }

    /*
    * componentDidMount - Initially it will call to get the products on page load
    */
    componentDidMount() {
        const { dispatch, match } = this.props;
        const { id } = match.params;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.merchantShopId = id;

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER_BY_ADMIN, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        const { dispatch } = props;

        // check if product data returned by API
        if (props.getProduct !== undefined) {
            if (props.getProduct.Product !== undefined &&
                props.getProduct.Product.data !== undefined &&
                props.getProduct.Product.data.allData !== undefined) {

                const prodData = props.getProduct.Product.data;

                this.setState({
                    allProducts: prodData.allData,
                    totalPage: prodData.pagination.totalPages,
                    totalDataCount: prodData.pagination.totalCount,
                })
            }
        }

        if (props.deleteProduct !== undefined) {
            if (props.deleteProduct.deletedProduct !== undefined &&
                props.deleteProduct.deletedProduct.data !== undefined &&
                props.deleteProduct.deletedProduct.data.type === "product-deleted") {

                if (this.state.deletePopup === true) {
                    // hide the conformation popup
                    this.closeDeletePopup();
                    //reload the table products again
                    this.reloadTable();
                }

            }
        }
    }

    reloadTable = () => {
        const { dispatch, match } = this.props;
        const { id } = match.params;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.merchantShopId = id;

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER_BY_ADMIN, postData));
    }


    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch, match } = this.props;
        const { id } = match.params;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.merchantShopId = id;

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER_BY_ADMIN, postData));
    }

    // hit api and get category data for selected list range
    changeTableData = (e) => {
        const { dispatch, match } = this.props;
        const { id } = match.params;

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.merchantShopId = id;
        postData.perPage = parseInt(e.target.value);

        dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER_BY_ADMIN, postData));
    }

    /*
    * searchCategories - User can search data from the database and it will appear
    */
    searchCategories(keyword) {
        const { dispatch, match } = this.props;
        const { id } = match.params;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        postData.merchantShopId = id;


        if (keyword.target.value !== '') {
            postData.search = keyword.target.value;
            dispatch(productActions.getProducts(apiConstants.SEARCH_PRODUCT_BY_KEYWORD_BY_ADMIN, postData));
        } else {
            dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER_BY_ADMIN, postData));
        }
    }

    //open add product popup
    openAddProducts = () => { this.setState({ productAdd: true }) }

    //close add product popup
    closeAddProductPop = (data) => {
        const { dispatch, match } = this.props;
        const { id } = match.params;
        this.setState({ productAdd: false });
        if (data === 1) {
            let postData = {};
            postData.page = 1;
            postData.orderBy = "id";
            postData.orderByAscDesc = "ASC";
            postData.perPage = config.perPageData;
            postData.merchantShopId = id;

            dispatch(productActions.getProducts(apiConstants.GET_PRODUCT_FOR_SHOPKEEPER_BY_ADMIN, postData));
        }
    }

    //open edit product popup
    viewProduct = (productData) => { this.setState({ viewProductData: productData, enableEdit: true }) }

    viewProductCopy = (product) => {
        const { history } = this.props;
        history.push('/product-details/'+product._id);
    }

    //close edit product popup
    closeViewProductPop = (data) => {
        this.setState({ viewProductData: false, enableEdit: false });
    }

    //delete product popup
    deletePopupOpen = (proId) => {
        this.setState({ deletingProdId: proId, deletePopup: true });
    }
    // close the popup and reset the id for deleting product
    closeDeletePopup = () => {
        this.setState({ deletingProdId: false, deletePopup: false });
    }

    //delete a product
    deletingProduct = () => {
        const { deletingProdId } = this.state;
        const { dispatch, match } = this.props;
        const { id } = match.params;
        if (deletingProdId) {
            const postData = {};
            postData.productId = deletingProdId;
            postData.merchantShopId = id;
            dispatch(productActions.deleteProducts(apiConstants.DELETE_PRODUCT_BY_SHOPKEEPER, postData));
        }
    }


    //-- Main function
    render() {
        console.log("allProducts",this.state.allProducts)
        const { classes, match, history } = this.props;
        const { id, shopname } = match.params;

        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/shop-list">{siteConstants.MENU_PRODUCTS}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    {siteConstants.LABEL_SHOPLIST}
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {shopname}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-2 text-gray-800">{/*}{siteConstants.LABEL_SHOP_PRODUCTS} {shopname}*/}</h1>
                                <a href="javascript:void(0)" className="darkLink" onClick={() => history.goBack()}><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}</a>
                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" placeholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" aria-controls="dataTable" onChange={(e) => this.searchCategories(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>



                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_PRODUCT_TITLE}</th>
                                                    <th scope="5%">{siteConstants.GEN_PRODUCT_REGULAR_PRICE}</th>
                                                    <th scope="col">Sell/Rent</th>
                                                    <th width="20%">{siteConstants.GEN_PRODUCT_CATEGORY}[Sub Category]</th>
                                                    <th width="7%">{siteConstants.GEN_PRODUCT_STOCK}</th>
                                                    {/* <th width="10%">{siteConstants.GEN_PRODUCT_SKU}</th> */}
                                                    <th width="12%">{siteConstants.GEN_PRODUCT_ADDED_DATE}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {
                                                    this.state.allProducts !== undefined &&
                                                        this.state.allProducts.length > 0 ?
                                                        this.state.allProducts.map((thisProd, index) => {
                                                            let crtdDate = new Date(thisProd.createdAt);
                                                            return (

                                                                <tr key={index}>
                                                                    <td scope="row">{index + 1}</td>
                                                                    {/*<td><a
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.viewProductCopy(thisProd)}>{thisProd.title}</a></td>*/}
                                                                    <td><a
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.viewProduct(thisProd)} >{thisProd.title}</a></td>
                                                                    <td>{thisProd.regularPrice}</td>
                                                                    <td>{thisProd.productSoldIndividually == 1 ? <p style={{ color: 'red' }}>Sell</p> : 'Rent'}</td>
                                                                    <td>{thisProd.categoryData.length > 0 ? thisProd.categoryData[0].categoryTitle : '--'} <b>[</b>{thisProd.subCategoryData.length > 0 ? thisProd.subCategoryData[0].categoryTitle : '--'}<b>]</b></td>
                                                                    <td>{thisProd.inStock}</td>
                                                                    {/* <td>{thisProd.sku}</td> */}
                                                                    <td>
                                                                        {crtdDate !== undefined ? crtdDate.toLocaleString("en-US", options) : ''}
                                                                    </td>
                                                                    <td>
                                                                        <a
                                                                            className="actionIcon"
                                                                            title="Edit"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.viewProduct(thisProd)}
                                                                        ><span><img src="assets/img/svg/eye-icon.png" alt="Edit" /></span></a>
                                                                        <a className="actionIcon"
                                                                            title="Delete"
                                                                            href="javascript:void(0)"
                                                                            onClick={() => this.deletePopupOpen(thisProd._id)}
                                                                        ><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        }) : <tr>
                                                            <td colSpan="8" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                        </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    {/* add product popup */}
                    {/* {
                        this.state.productAdd === true ? <AddProducts displayPopUp={this.state.productAdd} closeAddProductPop={(data)=>this.closeAddProductPop(data)}/> : ''
                    } */}

                    {/* view product info popup */}
                    {
                        this.state.viewProductData !== false ?
                            <Dialog open={true} aria-labelledby="product-info" >
                                <DialogTitle>{siteConstants.GEN_PRODUCT_DETAILS}</DialogTitle>
                                <DialogContent>
                                    <div class="row">

                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_TITLE_PLACEHOLDER}</label>
                                                <p>{this.state.viewProductData.title}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <label className={classes.boldText} >{siteConstants.LABEL_PRODUCT_DESCRIPTION_PLACEHOLDER}</label>
                                                <p>{this.state.viewProductData.description}</p>
                                            </div>
                                        </div>


                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_REGULAR_PRICE_PLACEHOLDER}</label>
                                                <p>{this.state.viewProductData.regularPrice}</p>
                                            </div>
                                        </div>


                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_SALE_PRICE}</label>
                                                <p>{this.state.viewProductData.salePrice ? this.state.viewProductData.salePrice : "--"}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>Advance Booking Amount</label>
                                                <p>{this.state.viewProductData.advance_booking_amount ? this.state.viewProductData.advance_booking_amount : "--"}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_MAIN_IMAGE}</label>
                                                <div className="col-md-12 col-xs-12">

                                                    {
                                                        this.state.viewProductData !== undefined &&
                                                            this.state.viewProductData.mainImage !== '' ?
                                                            <div className={classes.borderedImg}>
                                                                <img src={`${config.imgPath}` + '/uploads/products/' + this.state.viewProductData.mainImage} className={classes.pageImg} />
                                                            </div>
                                                            : 'NA'
                                                    }
                                                </div></div>
                                        </div>

                                        <div className="col-md-12 col-xs-12">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_IMAGE_GALLERY_PLACEHOLDER}</label>

                                                <div className="col-md-12 col-xs-12">
                                                    {
                                                        this.state.viewProductData !== undefined &&
                                                            this.state.viewProductData.imageGallery !== undefined &&
                                                            this.state.viewProductData.imageGallery.length > 0 ?
                                                            (
                                                                this.state.viewProductData.imageGallery.map((img, index) => {
                                                                    return <div className={classes.borderedImg}>
                                                                        <img src={`${config.imgPath}` + '/uploads/products/' + img} className={classes.pageImg} />
                                                                    </div>
                                                                })
                                                            ) : 'NA'
                                                    }
                                                </div> </div>

                                        </div>

                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_CATEGORY}</label>
                                                <p>{this.state.viewProductData.categoryData !== undefined && this.state.viewProductData.categoryData.length > 0 && this.state.viewProductData.categoryData[0].categoryTitle !== '' ?
                                                    this.state.viewProductData.categoryData[0].categoryTitle : 'NA'
                                                }</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_SUB_CATEGORY}</label>
                                                <p>{this.state.viewProductData.subCategoryData !== undefined && this.state.viewProductData.subCategoryData.length > 0 && this.state.viewProductData.subCategoryData[0].categoryTitle !== '' ?
                                                    this.state.viewProductData.subCategoryData[0].categoryTitle : 'NA'
                                                }</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_COUPON_PLACEHOLDER}</label>
                                                <p>NA</p>
                                            </div>

                                        </div>

                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_STOCK_PLACEHOLDER}</label>
                                                <p>{this.state.viewProductData.inStock ? this.state.viewProductData.inStock : "--"}</p>
                                            </div>

                                        </div>


                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.LABEL_PRODUCT_SKU_PLACEHOLDER}</label>
                                                <p>{this.state.viewProductData.sku ? this.state.viewProductData.sku : "--"}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.EXTRA_ADD_ONS}</label>
                                                <p>{ this.state.viewProductData &&
                                                     this.state.viewProductData.addonsData !== undefined &&
                                                     this.state.viewProductData.addonsData.length > 0 &&
                                                     this.state.viewProductData.addonsData.map( (data, index) => {
                                                       return(
                                                         <p>{index+1+")"} {data.addonTitle} : {config.currencyCode}{data.addonPrice}</p>
                                                       )
                                                     })
                                                   }

                                                   { this.state.viewProductData &&
                                                        this.state.viewProductData.addonsData !== undefined &&
                                                        this.state.viewProductData.addonsData.length ===0 && "--"}
                                                   </p>
                                            </div>
                                        </div>

                                        <div className="col-md-6 col-xs-6">
                                            <div className="form-group">
                                                <label className={classes.boldText}>{siteConstants.MENU_TAGS}</label>
                                                <p>{ this.state.viewProductData &&
                                                     this.state.viewProductData.tagData !== undefined &&
                                                     this.state.viewProductData.tagData.length > 0 &&
                                                     this.state.viewProductData.tagData.map( (data, index) => {

                                                       return( index+1+")"+" "+data.title+"  " )
                                                     })
                                                   }

                                                   { this.state.viewProductData &&
                                                        this.state.viewProductData.tagData !== undefined &&
                                                        this.state.viewProductData.tagData.length ===0 && "--"}
                                                   </p>
                                            </div>
                                        </div>
                                    </div>

                                </DialogContent>
                                <DialogActions>
                                    <Button variant="contained" onClick={() => this.closeViewProductPop(0)}>{siteConstants.LABEL_CLOSE}</Button>
                                </DialogActions>
                            </Dialog>
                            : ''
                    }

                    {/* add product popup */}
                    <Footer />
                    {/* notify saving data */}
                    <Dialog open={this.state.deletePopup} aria-labelledby="delete-product-notify" >
                        <DialogTitle>{siteConstants.GEN_ARE_SURE_TO_DELETE}</DialogTitle>
                        <DialogActions>
                            <Button variant="contained" onClick={() => this.closeDeletePopup(0)}>{siteConstants.LABEL_CANCEL}</Button>
                            <Button variant="contained" color="primary" onClick={(e) => this.deletingProduct(e)}>{siteConstants.GEN_DELETE_THIS}</Button>
                        </DialogActions>
                    </Dialog>

                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getProduct, deleteProduct } = state;
    return {
        language,
        getProduct,
        deleteProduct
    };
}
const connectedMembership = connect(mapStateToProps)(withStyles(styles)(ViewShopProducts));
export { connectedMembership as ViewShopProducts };